function HTMLPlain(props) {
    return props.replace(/(<([^>]+)>)/gi, '');
}

export default HTMLPlain;
